export default __webpack_public_path__ + "static/media/file-outline.199b8fe2.svg";